import '.a{display:grid;}.ssr-plugin'
import '.gb{grid-template-columns:repeat(2, 1fr);}.ssr-plugin'
import '.y{gap:1rem;}.ssr-plugin'
import Column from '@app/components/layout/Column'
import useMediaQuery from '@app/util/useMediaQuery'
import { InitiativeCard } from '@app/components/blocks/card/InitiativeCard'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'
import { SectionHeader } from '@app/components/blocks/sectionHeader/SectionHeader'
import { ServiceProviderConceptViewModel } from 'functions/app/service-provider-concept/view'
import { SafeHtml } from '@app/components/core/safeHtml/SafeHtml'
import {
  serviceProviderConceptTabs,
  serviceProviderConceptTabsQueryParamName,
} from '../../constants'
import { labelAddressBuilder } from '@app/util/helpers'

export const Overview = ({
  serviceProviderConcept,
}: {
  serviceProviderConcept: ServiceProviderConceptViewModel
}) => {
  const isMobile = useMediaQuery()
  const largerGap = isMobile ? '2rem' : '3.5rem'
  const smallerGap = isMobile ? '1.5rem' : '2rem'
  const translations = useTranslations().app

  return (
    <Column gap={largerGap}>
      <div>
        <SafeHtml html={serviceProviderConcept.body} />
      </div>

      <Column gap={smallerGap} alignItems="stretch">
        {/* Our Initiatives */}
        {serviceProviderConcept.initiatives?.length > 0 && (
          <div>
            <SectionHeader
              title={translations.serviceProviderConceptPage.initiatives}
              seeMore={translations.common.seeMore}
              toRoute={`?${serviceProviderConceptTabsQueryParamName}=${serviceProviderConceptTabs.initiatives}`}
            />
            <div className="a gb y"
            >
              {serviceProviderConcept.initiatives
                .slice(0, 2)
                ?.map((initiative) => (
                  <InitiativeCard
                    key={initiative.uuid}
                    tagText={
                      initiative.searchingForMembers
                        ? translations.common.initiativeStatus
                            .searchingForMembers
                        : translations.common.initiativeStatus
                            .notSearchingForMembers
                    }
                    image={initiative.images?.[0]?.src}
                    location={labelAddressBuilder(
                      initiative.location.address,
                      translations.common.notSpecified,
                    )}
                    phase={initiative.phase?.name}
                    title={initiative.title}
                    description={initiative.description}
                    variant="default"
                  />
                ))}
            </div>
          </div>
        )}
      </Column>
    </Column>
  )
}
